<po-loading-overlay *ngIf="!isHideLoading" p-screen-lock="true" [hidden]="isHideLoading" p-text="Carregando...">
</po-loading-overlay>

<div class="po-row po-m-5">
  <h2>{{ this.nome }}, bem-vindo!</h2>
  <br />
  <p></p>
</div>
<div class="po-row po-m-5">
  <po-container p-height="" p-no-border="false" p-no-padding="false" p-no-shadow="false">
    <font class="po-font-subtitle po-row po-md-5">Dúvidas?</font>
    <font class="po-font-text-large-bold po-row po-m-5">Consulte os vídeos abaixo:</font>

    <po-button class="po-md-5" p-label="Alteração de Senha" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('-0NQSumX5bk')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Inclusão de Orçamentos" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('9x11ecyFYtQ')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Visualização/Alteração/Impressão/Exclusão" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('aXzkScZu55M')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Efetivação do orçamento" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('A_pjEsJRaSA')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Envio de comprovante de pagamento" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('MgVf5ZlEt_8')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Envio da ordem de coleta" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('TeksOmE_VIc')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Consulta financeira" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('uZ7AxBrOwa4')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Área técnica" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('UTBkJS8vbso')" p-icon="po-icon po-icon-eye">
    </po-button>

    <po-button class="po-md-5" p-label="Envio de segunda via de boletos, Danfe e XML" p-type="link" p-kind="tertiary"
      (p-click)="OpenVideo('s4RJifP-KV0')" p-icon="po-icon po-icon-eye">
    </po-button>
  </po-container>
</div>

<po-modal #modal p-title="Empresa x Portal" [p-primary-action]="confirm" [p-secondary-action]="close"
  p-click-out="false" p-hide-close="true">
  <po-select name="portal" p-label="Portal" [(ngModel)]="Portal" [p-options]="options" p-placeholder="Selecione aqui"
    p-help="Selecione o portal de compras desejado para continuar." (p-change)="listaClientes()"
    [p-disabled]="selectDisable">
  </po-select>

  <po-select class="po-m-5" name="empresa" [(ngModel)]="EmpSegmento" p-icon="po-icon po-icon-search" p-label="Empresa"
    p-filter-mode="contains" [p-options]="EmpOpcao" p-placeholder="Selecione aqui"
    p-help="Selecione uma empresa para acessar o portal." p-required="true" p-disabled="{{ this.Portal }}">
  </po-select>
</po-modal>

<po-modal #aviso p-title="Aviso Importante">
  <div style="background: linear-gradient(135deg, #f9f9f9 60%, #e9ecef 100%);
              border: 2px solid #e53838; 
              border-radius: 12px; 
              padding: 32px 24px 20px 24px; 
              box-shadow: 0 3px 18px #0001; 
              font-family: 'Segoe UI', Arial, sans-serif;
              max-width: 800px;
              margin: 0 auto;">
    <p style="font-size: 1.1rem; font-weight: bold; color: #c0392b; margin-bottom: 16px; letter-spacing: 0.5px;">
      Prezados clientes e parceiros,
    </p>
    
    <p style="margin-bottom: 18px; color: #3d3d3d;">
      Diversas empresas têm sido alvo de quadrilhas especializadas em fraudes bancárias cuja atuação consiste na
      adulteração dos números dos códigos de barras em boletos de pagamentos ou criação de novos boletos com mesmos
      números de parcelas, valores e vencimentos, porém contendo agência e conta com dados do fraudador.
      O novo golpe consiste no envio de um boleto anexo a um e-mail informando uma divergência na base de cálculo da
      alíquota de ICMS/COFINS/CSLL, contendo várias informações que dão credibilidade ao teor da mensagem.
      Por esse motivo o Grupo BCI, vem esclarecer que:
    </p>
    <ol type="1" style="margin: 0 0 22px 18px; padding: 0; color: #333; font-size: 1rem;">
      <li style="margin-bottom: 10px;">Todos os <strong>BOLETOS</strong> enviados pela <strong>SHINERAY DO BRASIL LTDA</strong> são EMITIDOS exclusivamente através do <strong>BANCO SAFRA</strong>;</li>
      <li style="margin-bottom: 10px;">Nossos boletos são enviados em anexo a Nota Fiscal juntamente com os produtos adquiridos, e também estão
        disponíveis no <strong>Portal do Revendedor</strong>, com acesso através de seu logon e senha.</li>
      <li style="margin-bottom: 10px;">Os envios de boletos por e-mail só ocorrem pelo nosso <strong>departamento financeiro</strong>, quando o cliente nos solicita a
        2ª via do boleto.</li>
      <li style="margin-bottom: 10px;">Nossas comunicações utilizam <strong>EXCLUSIVAMENTE</strong> domínio <span style="color:#e53838;">&#64;grupobci.rec.br</span>, de forma que deve ser <strong>DESCONSIDERADA</strong>
        quaisquer mensagens enviadas em nome do GRUPO BCI a partir de outros provedores de e-mails, tais como GMAIL,
        TERRA, YAHOO, HOTMAIL, UOL, dentre outros.</li>
    </ol>
    <div style="background: #fff7e6; border-left: 4px solid #e53838; padding: 10px 16px; margin-bottom: 16px;">
      <p style=" margin: 0; color: #444;">
        Caso recebam quaisquer comunicados neste sentido, <strong>desconsiderem o teor da mensagem</strong>, e caso tenha alguma dúvida
        entre em contato com o nosso Departamento Financeiro através do e-mail: <span style="color:#e53838;"><strong>contasareceber&#64;grupobci.rec.br</strong></span>.
        Ressaltamos ainda que adotamos todas as medidas cabíveis, envolvendo as autoridades competentes para combater a
        prática de atividades criminosas.
      </p>
    </div>
    
    <div style="font-size: 0.99rem; color: #3E3E3E; border-top: 1px dotted #e53838; padding-top: 14px;">
      <p style="margin: 0 0 2px 0;"><strong>Atenciosamente,</strong></p>
      <strong>SHINERAY DO BRASIL LTDA</strong><br>
      <span style="color: #777;">CNPJ: 12.482.805/0001-06</span>
    </div>
  </div>
</po-modal>